<ng-container [formGroup]="editorForm">
  <div class="float-container">
    <div
      class="form-group col-auto"
      [ngClass]="customClass"
      [formGroup]="editorForm"
      [ngbTooltip]="actualConfig.placeholder | abpLocalization"
      [disableTooltip]="(actualConfig.placeholder | abpLocalization).length < 50">
      <label
        *ngIf="actualConfig.label && actualConfig.label.length > 0"
        [for]="'text-editor-' + this.actualConfig.key"
        [ngClass]="labelClass">
        {{ actualConfig.label | abpLocalization }}
      </label>
      <div class="input-wrapper" *ngIf="hasIcon">
        <i [ngClass]="actualConfig.iconCls"></i>
        <input
          id="quickSearchTextWithIcon"
          type="text"
          formControlName="quickSearchText"
          class="form-control form-control-sm editor"
          [placeholder]="actualConfig.placeholder | abpLocalization"
          #quickSearchTextPopover="ngbPopover"
          [ngbPopover]="quickSearchTextPopContent"
          popoverClass="quick-search-popover"
          placement="bottom auto"
          container="body" />
      </div>
      <input
        *ngIf="!hasIcon"
        id="quickSearchTextWithoutIcon"
        type="text"
        formControlName="quickSearchText"
        class="form-control form-control-sm"
        [placeholder]="actualConfig.placeholder | abpLocalization"
        #quickSearchTextPopover="ngbPopover"
        [ngbPopover]="quickSearchTextPopContent"
        popoverClass="quick-search-popover"
        placement="bottom auto"
        container="body" />
    </div>

    <div class="col-auto">
      <ca-conversation-side-selector
        [ngbTooltip]="'::QuickSearch:Filter:DisabledTooltip' | abpLocalization"
        [disableTooltip]="!channelSelectorDisabled"
        [disabled]="channelSelectorDisabled"
        formControlName="sideId"
        container="body"
        placement="bottom"></ca-conversation-side-selector>
    </div>
  </div>
</ng-container>

<ng-template #quickSearchTextPopContent>
  <div class="expandable-header-search-help">
    <div class="search-help">
      <div class="search-filter-caption">{{ '::FilterByField' | abpLocalization }}</div>
      <ul class="search-filter-list detailed">
        <li
          class="search-filter-item"
          tabindex="-1"
          *ngIf="!hideExternalIdInformation"
          (click)="changeText()">
          <div class="search-filter-text">{{ '::FilterByExtIdLabel' | abpLocalization }}</div>
          <div class="search-filter-hint">{{ '::FilterByExtIdText' | abpLocalization }}</div>
        </li>
        <li
          *ngIf="channelFilterVisible"
          class="search-filter-item"
          (click)="changeText('ag:')"
          container="body"
          placement="bottom"
          tabindex="-1">
          <div class="search-filter-text">{{ '::FilterByAgentLabel' | abpLocalization }}</div>
          <div class="search-filter-hint">{{ '::FilterByAgentText' | abpLocalization }}</div>
        </li>
        <li
          *ngIf="channelFilterVisible"
          class="search-filter-item"
          (click)="changeText('cu:')"
          container="body"
          placement="bottom"
          tabindex="-1">
          <div class="search-filter-text">{{ '::FilterByCustomerLabel' | abpLocalization }}</div>
          <div class="search-filter-hint">{{ '::FilterByCustomerText' | abpLocalization }}</div>
        </li>
      </ul>
    </div>
    <div style="font-size: 11px">
      <div class="search-filter-caption" style="float: left; margin-right: 5px">
        {{ '::QuickSearch:Operators' | abpLocalization }}
      </div>
    </div>
    <div class="search-help">
      <div class="search-filter-hint">{{ '::QuickSearch:Operator:Hint1' | abpLocalization }}</div>
      <div class="search-filter-hint">{{ '::QuickSearch:Operator:Hint2' | abpLocalization }}</div>
      <div class="search-filter-hint">{{ '::QuickSearch:Operator:Hint3' | abpLocalization }}</div>
      <div class="search-filter-hint">{{ '::QuickSearch:Operator:Hint4' | abpLocalization }}</div>
    </div>
    <div class="search-help">
      <div class="search-filter-text search-filter-item" (click)="changeText('AND')">AND</div>
      <div class="search-filter-text search-filter-item" (click)="changeText('OR')">OR</div>
      <div class="search-filter-text search-filter-item" (click)="changeText('NEAR')">NEAR</div>
      <div class="search-filter-text search-filter-item" (click)="changeText('NOT')">NOT</div>
    </div>
  </div>
</ng-template>
